import React from 'react'
import PropTypes from 'prop-types';
import {FormGroup, FormControl, Col, Radio} from 'react-bootstrap'
import _ from 'lodash'
import I18n from 'PMT/i18n/I18n'

import ArrayUtils from 'PMT/utils/ArrayUtils'
import CategoryItem from 'PMT/entities/menu/CategoryItem'

import ItemsList from './ItemsList'


function handleChange(conditionRule, selectedItems, type) {
  // remove all items that were set with the given `type`
  const other = (conditionRule.itemsList || []).filter(item => item.type !== type)

  // map a CategoryItem to {id / type}
  const items = selectedItems.map((item) => ({
    id: item.id,
    type: type,
  }))

  conditionRule.itemsList = [...other, ...items]
  return conditionRule
}

function filterItemsByType(itemsList, type) {
  return (itemsList || []).filter((item) => (
    item.type === type
  ))
}

const ConditionRule = ({ restaurantMenu, conditionRule, onChange, onDelete, onDisplayItemSelector }) =>  {
  try {
return (
  <div>
    <FormGroup>
      <Col componentClass="label" className="text-left control-label" sm={4}>
        {I18n.tr('order.cart_modifiers.condition_rule.min')}
      </Col>
      <Col sm={2}>
        <FormControl
          type="number"
          value={conditionRule.itemsNumber}
          onChange={(e) => {
            conditionRule.itemsNumber = e.target.value
            onChange(conditionRule)
          }}
        />
      </Col>
      <a className="col-xs-1 text-right pull-right link" onClick={() => onDelete(conditionRule)}>
        <i className="fa fa-trash" />
      </a>
    </FormGroup>
    <FormGroup>

      <Col sm={12}>
        <div
          className="btn btn-primary btn-cta"
          onClick={() => onDisplayItemSelector(conditionRule)}
          style={{
            marginBottom: '40px',
          }}
        >
          Modifier les éléments
        </div>
      </Col>

      <Col sm={4}>
        <ItemsList
          restaurantMenu={restaurantMenu}
          type={CategoryItem.Type.CATEGORY}
          items={filterItemsByType(conditionRule.itemsList, CategoryItem.Type.CATEGORY)}
        />
      </Col>
      <Col sm={4}>
        <ItemsList
          restaurantMenu={restaurantMenu}
          type={CategoryItem.Type.PRODUCT}
          items={filterItemsByType(conditionRule.itemsList, CategoryItem.Type.PRODUCT)}
        />
      </Col>
      <Col sm={4}>
        <ItemsList
          restaurantMenu={restaurantMenu}
          type={CategoryItem.Type.MENU}
          items={filterItemsByType(conditionRule.itemsList, CategoryItem.Type.MENU)}
        />
      </Col>
    </FormGroup>
  </div>
)
} catch (e) { console.error(e)}
}

ConditionRule.propTypes = {
  restaurantMenu: PropTypes.object.isRequired,
  conditionRule: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
}

export default ConditionRule
